/**
 * Custom D1 Tawk launcher: hide their pill, show ours, route pings to a toast.
 */
(function () {
  'use strict';

  function initTawkLauncher() {
    const btn = document.querySelector('[data-d1-tawk-launcher]');
    if (!btn) return;

    const badge = btn.querySelector('[data-d1-tawk-badge]');
    const toast = document.querySelector('[data-d1-tawk-toast]');
    const toastText = toast && toast.querySelector('[data-d1-tawk-toast-text]');
    let unread = 0;
    let toastTimer = 0;

    const api = () => window.Tawk_API || {};
    const hideBubble = () => {
      try {
        if (typeof api().hideWidget === 'function') api().hideWidget();
      } catch (_) {}
    };
    const setOpen = (open) => {
      btn.classList.toggle('is-open', !!open);
      document.body.classList.toggle('d1-tawk-open', !!open);
      if (open) {
        unread = 0;
        renderUnread();
        hideToast();
      }
    };
    const renderUnread = () => {
      btn.classList.toggle('has-unread', unread > 0);
      if (!badge) return;
      badge.hidden = unread < 1;
      badge.textContent = unread > 9 ? '9+' : String(unread);
    };
    const hideToast = () => {
      if (toastTimer) window.clearTimeout(toastTimer);
      toastTimer = 0;
      if (toast) toast.hidden = true;
    };
    const cleanMessage = (message) => {
      const raw = typeof message === 'string' ? message : (message && (message.text || message.message)) || '';
      return String(raw)
        .replace(/<[^>]+>/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .slice(0, 140);
    };
    const fillToastText = (el, text) => {
      el.replaceChildren();
      String(text)
        .split(/(\*\*[^*]+?\*\*)/g)
        .forEach((part) => {
          const bold = part.match(/^\*\*([^*]+)\*\*$/);
          if (bold) {
            const strong = document.createElement('strong');
            strong.textContent = bold[1];
            el.appendChild(strong);
            return;
          }
          if (part) el.appendChild(document.createTextNode(part));
        });
    };
    const ping = (message) => {
      hideBubble();
      if (document.body.classList.contains('d1-tawk-open')) return;
      unread += 1;
      renderUnread();
      const text = cleanMessage(message);
      if (!toast || !toastText || !text) return;
      fillToastText(toastText, text);
      toast.hidden = false;
      if (toastTimer) window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(hideToast, 12000);
    };

    window.Tawk_API = window.Tawk_API || {};
    const prevOnLoad = window.Tawk_API.onLoad;
    window.Tawk_API.onLoad = function () {
      if (typeof prevOnLoad === 'function') prevOnLoad.apply(this, arguments);
      hideBubble();
      if (typeof api().showWidget === 'function' && !api().showWidget.__d1Locked) {
        api().showWidget = function () {
          hideBubble();
        };
        api().showWidget.__d1Locked = true;
      }
    };
    window.Tawk_API.onChatMaximized = function () {
      setOpen(true);
    };
    window.Tawk_API.onChatMinimized = function () {
      setOpen(false);
      hideBubble();
    };
    window.Tawk_API.onChatHidden = function () {
      setOpen(false);
      hideBubble();
    };
    window.Tawk_API.onChatMessageAgent = function (message) {
      ping(message);
    };
    window.Tawk_API.onChatMessageSystem = function (message) {
      ping(message);
    };

    const openChat = () => {
      const tawk = api();
      if (typeof tawk.maximize !== 'function') return;
      if (typeof tawk.isChatMaximized === 'function' && tawk.isChatMaximized()) {
        tawk.minimize();
        return;
      }
      document.body.classList.add('d1-tawk-open');
      tawk.maximize();
    };

    btn.addEventListener('click', openChat);
    if (toast) toast.addEventListener('click', openChat);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTawkLauncher);
  } else {
    initTawkLauncher();
  }
})();
